import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../../actions';

import Schedule from './Schedule';

const mapStateToProps = state => {
  const { username } = state.auth;
  const { schedule, recipients } = state.reports;
  return {
    username,
    recipients,
    schedule
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Schedule/ScheduleContainer.js